import { UATConstants } from 'src/Common/Models/UATConstants';

export const HelpLinks = [
  {
    key: 'whats-new',
    label: "What's New",
    items: [
      // {
      //   key: 'whats-new-item',
      //   text: UATConstants.PlaceholdersAndTitles.UATisNowAction360,
      // },
    ],
  },
  {
    key: 'resources',
    label: 'Resources',
    items: [
      {
        key: 'documentation',
        text: UATConstants.PlaceholdersAndTitles.Documentation,
        url: UATConstants.Links.documentationLink,
      },
      {
        key: 'tech-rob-docs',
        text: UATConstants.PlaceholdersAndTitles.TechRobProcessDocumentation,
        url: UATConstants.Links.techRobProcessDocumentationLink,
      },
    ],
  },
  {
    key: 'contact-us',
    label: 'Contact Us',
    items: [
      {
        key: 'support',
        text: UATConstants.PlaceholdersAndTitles.RequestHelpSupport2,
        url: UATConstants.Links.uatSupportLink,
      },
      {
        key: 'feedback',
        text: UATConstants.PlaceholdersAndTitles.FeedbackFeatureRequest,
        url: UATConstants.Links.userFeedbackLink,
      },
    ],
  },
  {
    key: 'privacy',
    label: 'Privacy',
    items: [
      {
        key: 'privacy-statement',
        text: UATConstants.PlaceholdersAndTitles.PrivacyStatement,
        url: UATConstants.Links.privacy,
      },
      {
        key: 'terms-of-use',
        text: UATConstants.PlaceholdersAndTitles.TermsOfUse,
        url: UATConstants.Links.termsOfUse,
      },
      {
        key: 'cookies',
        text: UATConstants.PlaceholdersAndTitles.CookiesStatement,
        url: UATConstants.Links.cookies,
      },
    ],
  },
];
